import type {
  PublishedLegendResource,
  ServiceTypeResource,
  TemplateResource,
} from '@/features/jobs/api/resources/legend'
import { maybeParseDate } from '@/utils/date-util'
import type { LegendTemplate, PublishedLegendProps } from './PublishedLegend'
import type { LegendServiceType } from './legend-service-type'

/**
 * Maps a legend resource to props, except for the workspace, which the store primes.
 */
export function mapPublishedLegendResourceToProps(
  resource: PublishedLegendResource,
): Partial<PublishedLegendProps> {
  return {
    id: resource.id,
    imageUrl: resource.image_url,
    viewOrder: resource.view_order,
    version: resource.version,
    name: resource.name,
    serviceType: resource.service_type
      ? mapServiceTypeResourceToServiceType(resource.service_type)
      : undefined,
    inactive: resource.inactive,
    description: resource.description,
    dateCreated: maybeParseDate(resource.date_created),
    allowScheduling: resource.allowScheduling,
    allowProSelection: resource.allowProSelection,
    skipBilling: resource.skipBilling,
    skipQuote: resource.skipQuote,
    priceUnit: resource.priceUnit,
    showAvailabilityCount: resource.showAvailabilityCount,
    templates: resource.templates?.map(mapTemplateResourceToLegendTemplate),
  }
}

function mapServiceTypeResourceToServiceType(
  serviceType: ServiceTypeResource,
): LegendServiceType {
  switch (serviceType) {
    case 'TAX':
      return 'Tax'
    case 'MISC':
      return 'Misc'
    case 'BOOKKEEPING':
      return 'Bookkeeping'
    case 'CONSULTATION':
      return 'Consultation'
  }
}

function mapTemplateResourceToLegendTemplate(
  resource: TemplateResource,
): LegendTemplate {
  return {
    id: resource.id,
    name: resource.name,
  }
}
